var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1569.787,
    height: 1214.862,
    viewBox: "0 0 1569.787 1214.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M970.2,196.092,941,635.683a92.969,92.969,0,0,1-92.969,92.969h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H201.028l29.2-377.58Z",
    transform: "translate(-201.028 -196.092)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3080-2",
    "data-name": "Path 3080",
    d: "M970.2,196.092,941,635.683a92.969,92.969,0,0,1-92.969,92.969h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H201.028l29.2-377.58Z",
    transform: "translate(-201.028 -196.092)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NoHistory",
    transform: "translate(-2212.43 -3312.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Email_update",
    "data-name": "Email update",
    transform: "translate(2019 1505.117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail",
    transform: "translate(-4530.33 -1494.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(-2077.952 3178.162)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M1361.367,1177.549c209.991-204.2,220.738-517.33-158.32-868.486-54.978-51.051-81.847-122.15-136.411-160.387-165.347-115.95-397.453-92.388-543.579,79.78C443.07,322.7,410.827,452.088,327.74,544.476,234.526,648.231,122.916,749.093,80.546,890.465c-28.109,93.628-23.355,195.73,8.681,287.291C549.719,1259.6,985,1284.818,1361.367,1177.549Z",
    transform: "translate(6769.949 45.96)",
    fill: "#c2b59c",
    opacity: 0.1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645",
    transform: "translate(2212.43 4029.048)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    "data-name": "Path 3244",
    d: "M900.1,595.78A154.105,154.105,0,1,0,1054.2,749.885,154.106,154.106,0,0,0,900.1,595.78Zm0,282.855a128.75,128.75,0,1,1,128.75-128.75A128.835,128.835,0,0,1,900.1,878.635Z",
    transform: "translate(-745.99 -595.78)",
    fill: "#acd6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    "data-name": "Path 3245",
    d: "M840.843,670.37a20.292,20.292,0,1,1-20.28-20.28A20.265,20.265,0,0,1,840.843,670.37Z",
    transform: "translate(-666.533 -516.264)",
    fill: "#acd6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    d: "M816.23,614.02a13.014,13.014,0,0,0-13.01,13.01V717.39a13.01,13.01,0,0,0,26.021,0V627.031A13,13,0,0,0,816.23,614.02Z",
    transform: "translate(-662.199 -569.075)",
    fill: "#acd6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    "data-name": "Path 3247",
    d: "M890.509,631.392a13,13,0,0,0-18.383,0l-63.894,63.894a13,13,0,0,0,18.383,18.382l63.894-63.894A12.955,12.955,0,0,0,890.509,631.392Z",
    transform: "translate(-660.435 -549.214)",
    fill: "#acd6ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7bdc07120c027be48c81a0b2532a9b05",
    "data-name": "7bdc07120c027be48c81a0b2532a9b05",
    transform: "translate(2366.535 3482.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    "data-name": "Path 3051",
    d: "M1059.149,992.162H199.578a14.745,14.745,0,0,1-14.73-15.408L220.379,188.81a14.745,14.745,0,0,1,14.73-14.08H1094.68a14.745,14.745,0,0,1,14.729,15.409l-35.531,787.943A14.745,14.745,0,0,1,1059.149,992.162Z",
    transform: "translate(-82.411 -128.661)",
    fill: "#83a87f",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    "data-name": "Path 3052",
    d: "M477.3,188.811a14.744,14.744,0,0,0-14.729-14.08h-5.014a14.745,14.745,0,0,1,14.73,15.409L436.754,978.082a14.744,14.744,0,0,1-14.729,14.081h149.8a14.744,14.744,0,0,0,14.73-15.409Z",
    transform: "translate(554.713 -128.661)",
    fill: "#3d4b3b",
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M971.616,909.576h-759.1A13.021,13.021,0,0,1,199.5,895.969l31.379-695.844a13.021,13.021,0,0,1,13.008-12.434H1003A13.021,13.021,0,0,1,1016,201.3L984.625,897.144a13.021,13.021,0,0,1-13.01,12.432Z",
    transform: "translate(-43.036 -93.847)",
    fill: "#749072",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    "data-name": "Path 3054",
    d: "M280.518,205.8a5.267,5.267,0,0,1-.627,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.642,14.892-20.642,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.916,30,20.568,30a10.773,10.773,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.935,21.935,0,0,1-3.465.258c-16.846,0-30.705-18.209-31.664-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.7-43.57C266.29,162.232,280.518,181.768,280.518,205.8Z",
    transform: "translate(4.208 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    "data-name": "Path 3055",
    d: "M310.785,205.8a5.267,5.267,0,0,1-.627,2.507h-9.8a5.264,5.264,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.774,10.774,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.935,21.935,0,0,1-3.465.258c-16.883,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C296.52,162.232,310.785,181.768,310.785,205.8Z",
    transform: "translate(85.409 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3056",
    "data-name": "Path 3056",
    d: "M340.988,205.8a5.266,5.266,0,0,1-.627,2.507h-9.805a5.267,5.267,0,0,1-.627-2.507c0-17.62-9.473-32.512-20.642-32.512-11.206,0-20.679,14.892-20.679,32.512,0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.657,10.657,0,0,0,1.843-.147,5.534,5.534,0,0,1,1.622,10.948,22.6,22.6,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C326.76,162.232,340.988,181.768,340.988,205.8Z",
    transform: "translate(166.637 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3057",
    "data-name": "Path 3057",
    d: "M371.255,205.8a5.264,5.264,0,0,1-.627,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.937,21.937,0,0,1-3.465.258c-16.845,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.265-43.57,31.737-43.57C357.027,162.232,371.255,181.768,371.255,205.8Z",
    transform: "translate(247.838 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    "data-name": "Path 3058",
    d: "M401.458,205.8a5.266,5.266,0,0,1-.627,2.507h-9.8a5.267,5.267,0,0,1-.627-2.507c0-17.62-9.436-32.511-20.642-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.885,17.472,11.132,31.516,22.448,29.858a5.534,5.534,0,1,1,1.622,10.948,22.276,22.276,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C387.23,162.232,401.458,181.768,401.458,205.8Z",
    transform: "translate(329.066 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    "data-name": "Path 3059",
    d: "M431.7,205.8a5.265,5.265,0,0,1-.626,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.642,14.892-20.642,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.916,30,20.568,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,0,1,1.585,10.948,21.929,21.929,0,0,1-3.465.258c-16.845,0-30.705-18.209-31.664-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.229-43.57,31.7-43.57C417.47,162.232,431.7,181.768,431.7,205.8Z",
    transform: "translate(410.294 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3060",
    "data-name": "Path 3060",
    d: "M459.755,205.8a5.265,5.265,0,0,1-.627,2.507h-9.8a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,22.271,22.271,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C445.49,162.232,459.755,181.768,459.755,205.8Z",
    transform: "translate(485.559 -162.232)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3061",
    "data-name": "Path 3061",
    d: "M450.165,368.694H437.89v-.442Q443.972,368.694,450.165,368.694Z",
    transform: "translate(597.328 391.161)",
    fill: "#25788e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3062",
    "data-name": "Path 3062",
    d: "M970.2,196.092,941,635.683a92.969,92.969,0,0,1-92.969,92.969h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H201.028l29.2-377.58Z",
    transform: "translate(-38.909 -71.28)",
    fill: "#6a8967"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(162.119 124.812)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3064",
    "data-name": "Path 3064",
    d: "M365.447,344.154H232.68a10.523,10.523,0,0,1-10.513-11L227.6,212.77a10.523,10.523,0,0,1,10.513-10.049H370.874a10.523,10.523,0,0,1,10.513,11L375.958,334.1a10.523,10.523,0,0,1-10.511,10.049Z",
    transform: "translate(-144.273 -178.286)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M410.915,344.154H278.153a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H416.345a10.523,10.523,0,0,1,10.513,11l-5.43,120.387A10.523,10.523,0,0,1,410.915,344.154Z",
    transform: "translate(-22.13 -178.286)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M456.386,344.154H323.624a10.523,10.523,0,0,1-10.513-11L318.54,212.77a10.523,10.523,0,0,1,10.513-10.049H461.816a10.524,10.524,0,0,1,10.513,11L466.9,334.1a10.524,10.524,0,0,1-10.514,10.049Z",
    transform: "translate(100.01 -178.286)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M501.861,344.154H369.095a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H507.287a10.524,10.524,0,0,1,10.513,11L512.371,334.1A10.523,10.523,0,0,1,501.861,344.154Z",
    transform: "translate(222.15 -178.286)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M363.394,386.634H230.628a10.524,10.524,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,236.056,245.2H368.82a10.523,10.523,0,0,1,10.513,11L373.9,376.585A10.524,10.524,0,0,1,363.394,386.634Z",
    transform: "translate(-149.788 -64.18)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M408.862,386.634H276.1a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.524,10.524,0,0,1,281.529,245.2H414.292a10.523,10.523,0,0,1,10.513,11l-5.43,120.387a10.523,10.523,0,0,1-10.513,10.048Z",
    transform: "translate(-27.645 -64.18)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    "data-name": "Path 3070",
    d: "M454.333,386.634H321.571a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,327,245.2H459.763a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,454.333,386.634Z",
    transform: "translate(94.496 -64.18)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    d: "M499.808,386.634H367.042a10.524,10.524,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,372.47,245.2H505.234a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.524,10.524,0,0,1,499.808,386.634Z",
    transform: "translate(216.636 -64.18)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    d: "M362.015,429.114H229.248a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H367.441a10.524,10.524,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,362.015,429.114Z",
    transform: "translate(-153.492 49.926)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    d: "M407.483,429.114H274.721a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H412.913a10.524,10.524,0,0,1,10.513,11L418,419.066a10.523,10.523,0,0,1-10.513,10.048Z",
    transform: "translate(-31.349 49.926)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M452.954,429.114H320.192a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H458.384a10.524,10.524,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,452.954,429.114Z",
    transform: "translate(90.791 49.926)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M498.429,429.114H365.663a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H503.855a10.523,10.523,0,0,1,10.513,11l-5.429,120.387a10.523,10.523,0,0,1-10.51,10.049Z",
    transform: "translate(212.931 49.926)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M360.366,471.436H227.6a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.524,10.524,0,0,1,233.032,330H365.8a10.523,10.523,0,0,1,10.513,11L370.88,461.387A10.523,10.523,0,0,1,360.366,471.436Z",
    transform: "translate(-157.91 163.607)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M405.837,471.436H273.075a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,278.5,330H411.267a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,405.837,471.436Z",
    transform: "translate(-35.77 163.607)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M451.309,471.436H318.547a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,323.975,330H456.739a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,451.309,471.436Z",
    transform: "translate(86.373 163.607)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    d: "M496.78,471.436H364.018a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,369.446,330H502.21a10.523,10.523,0,0,1,10.513,11l-5.429,120.387a10.523,10.523,0,0,1-10.514,10.049Z",
    transform: "translate(208.513 163.607)",
    fill: "#f9f7e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M0,74.394",
    transform: "translate(96.701 221.958)",
    fill: "none",
    stroke: "#ee781d",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M99.518,0",
    transform: "translate(-99.518 548.711)",
    fill: "none",
    stroke: "#3086a3",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7bdc07120c027be48c81a0b2532a9b05-2",
    "data-name": "7bdc07120c027be48c81a0b2532a9b05",
    transform: "translate(2366.535 3482.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3051-2",
    "data-name": "Path 3051",
    d: "M1059.149,992.162H199.578a14.745,14.745,0,0,1-14.73-15.408L220.379,188.81a14.745,14.745,0,0,1,14.73-14.08H1094.68a14.745,14.745,0,0,1,14.729,15.409l-35.531,787.943A14.745,14.745,0,0,1,1059.149,992.162Z",
    transform: "translate(-82.411 -128.661)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052-2",
    "data-name": "Path 3052",
    d: "M477.3,188.811a14.744,14.744,0,0,0-14.729-14.08h-5.014a14.745,14.745,0,0,1,14.73,15.409L436.754,978.082a14.744,14.744,0,0,1-14.729,14.081h149.8a14.744,14.744,0,0,0,14.73-15.409Z",
    transform: "translate(554.713 -128.661)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053-2",
    "data-name": "Path 3053",
    d: "M971.616,909.576h-759.1A13.021,13.021,0,0,1,199.5,895.969l31.379-695.844a13.021,13.021,0,0,1,13.008-12.434H1003A13.021,13.021,0,0,1,1016,201.3L984.625,897.144a13.021,13.021,0,0,1-13.01,12.432Z",
    transform: "translate(-43.036 -93.847)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3054-2",
    "data-name": "Path 3054",
    d: "M280.518,205.8a5.267,5.267,0,0,1-.627,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.642,14.892-20.642,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.916,30,20.568,30a10.773,10.773,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.935,21.935,0,0,1-3.465.258c-16.846,0-30.705-18.209-31.664-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.7-43.57C266.29,162.232,280.518,181.768,280.518,205.8Z",
    transform: "translate(4.208 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3055-2",
    "data-name": "Path 3055",
    d: "M310.785,205.8a5.267,5.267,0,0,1-.627,2.507h-9.8a5.264,5.264,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.774,10.774,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.935,21.935,0,0,1-3.465.258c-16.883,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C296.52,162.232,310.785,181.768,310.785,205.8Z",
    transform: "translate(85.409 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3056-2",
    "data-name": "Path 3056",
    d: "M340.988,205.8a5.266,5.266,0,0,1-.627,2.507h-9.805a5.267,5.267,0,0,1-.627-2.507c0-17.62-9.473-32.512-20.642-32.512-11.206,0-20.679,14.892-20.679,32.512,0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.657,10.657,0,0,0,1.843-.147,5.534,5.534,0,0,1,1.622,10.948,22.6,22.6,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C326.76,162.232,340.988,181.768,340.988,205.8Z",
    transform: "translate(166.637 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3057-2",
    "data-name": "Path 3057",
    d: "M371.255,205.8a5.264,5.264,0,0,1-.627,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,21.937,21.937,0,0,1-3.465.258c-16.845,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.265-43.57,31.737-43.57C357.027,162.232,371.255,181.768,371.255,205.8Z",
    transform: "translate(247.838 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3058-2",
    "data-name": "Path 3058",
    d: "M401.458,205.8a5.266,5.266,0,0,1-.627,2.507h-9.8a5.267,5.267,0,0,1-.627-2.507c0-17.62-9.436-32.511-20.642-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.885,17.472,11.132,31.516,22.448,29.858a5.534,5.534,0,1,1,1.622,10.948,22.276,22.276,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C387.23,162.232,401.458,181.768,401.458,205.8Z",
    transform: "translate(329.066 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3059-2",
    "data-name": "Path 3059",
    d: "M431.7,205.8a5.265,5.265,0,0,1-.626,2.507h-9.805a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.642,14.892-20.642,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.916,30,20.568,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,0,1,1.585,10.948,21.929,21.929,0,0,1-3.465.258c-16.845,0-30.705-18.209-31.664-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.229-43.57,31.7-43.57C417.47,162.232,431.7,181.768,431.7,205.8Z",
    transform: "translate(410.294 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3060-2",
    "data-name": "Path 3060",
    d: "M459.755,205.8a5.265,5.265,0,0,1-.627,2.507h-9.8a5.266,5.266,0,0,1-.627-2.507c0-17.62-9.473-32.511-20.679-32.511s-20.679,14.892-20.679,32.512c0,.848.037,1.659.074,2.507.848,16.514,9.953,30,20.605,30a10.788,10.788,0,0,0,1.88-.147,5.531,5.531,0,1,1,1.585,10.948,22.271,22.271,0,0,1-3.465.258c-16.882,0-30.742-18.209-31.7-41.063-.037-.848-.037-1.659-.037-2.507,0-24.033,14.228-43.57,31.737-43.57C445.49,162.232,459.755,181.768,459.755,205.8Z",
    transform: "translate(485.559 -162.232)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M268.779,453.5h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H837.951l9.781,74.165A92.969,92.969,0,0,0,939.9,453.5Z",
    transform: "translate(-137.777 203.866)",
    fill: "#466543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3061-2",
    "data-name": "Path 3061",
    d: "M450.165,368.694H437.89v-.442Q443.972,368.694,450.165,368.694Z",
    transform: "translate(597.328 391.161)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3062-2",
    "data-name": "Path 3062",
    d: "M970.2,196.092,941,635.683a92.969,92.969,0,0,1-92.969,92.969h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H201.028l29.2-377.58Z",
    transform: "translate(-38.909 -71.28)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3063",
    "data-name": "Path 3063",
    d: "M268.779,453.5h0a92.969,92.969,0,0,1-92.171-80.814l-9.781-74.165H837.951l9.781,74.165A92.969,92.969,0,0,0,939.9,453.5Z",
    transform: "translate(-130.778 203.866)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_613-2",
    "data-name": "Group 613",
    transform: "translate(162.119 124.812)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3064-2",
    "data-name": "Path 3064",
    d: "M365.447,344.154H232.68a10.523,10.523,0,0,1-10.513-11L227.6,212.77a10.523,10.523,0,0,1,10.513-10.049H370.874a10.523,10.523,0,0,1,10.513,11L375.958,334.1a10.523,10.523,0,0,1-10.511,10.049Z",
    transform: "translate(-144.273 -178.286)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065-2",
    "data-name": "Path 3065",
    d: "M410.915,344.154H278.153a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H416.345a10.523,10.523,0,0,1,10.513,11l-5.43,120.387A10.523,10.523,0,0,1,410.915,344.154Z",
    transform: "translate(-22.13 -178.286)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066-2",
    "data-name": "Path 3066",
    d: "M456.386,344.154H323.624a10.523,10.523,0,0,1-10.513-11L318.54,212.77a10.523,10.523,0,0,1,10.513-10.049H461.816a10.524,10.524,0,0,1,10.513,11L466.9,334.1a10.524,10.524,0,0,1-10.514,10.049Z",
    transform: "translate(100.01 -178.286)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067-2",
    "data-name": "Path 3067",
    d: "M501.861,344.154H369.095a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H507.287a10.524,10.524,0,0,1,10.513,11L512.371,334.1A10.523,10.523,0,0,1,501.861,344.154Z",
    transform: "translate(222.15 -178.286)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068-2",
    "data-name": "Path 3068",
    d: "M363.394,386.634H230.628a10.524,10.524,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,236.056,245.2H368.82a10.523,10.523,0,0,1,10.513,11L373.9,376.585A10.524,10.524,0,0,1,363.394,386.634Z",
    transform: "translate(-149.788 -64.18)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069-2",
    "data-name": "Path 3069",
    d: "M408.862,386.634H276.1a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.524,10.524,0,0,1,281.529,245.2H414.292a10.523,10.523,0,0,1,10.513,11l-5.43,120.387a10.523,10.523,0,0,1-10.513,10.048Z",
    transform: "translate(-27.645 -64.18)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3070-2",
    "data-name": "Path 3070",
    d: "M454.333,386.634H321.571a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,327,245.2H459.763a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,454.333,386.634Z",
    transform: "translate(94.496 -64.18)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071-2",
    "data-name": "Path 3071",
    d: "M499.808,386.634H367.042a10.524,10.524,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,372.47,245.2H505.234a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.524,10.524,0,0,1,499.808,386.634Z",
    transform: "translate(216.636 -64.18)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072-2",
    "data-name": "Path 3072",
    d: "M362.015,429.114H229.248a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H367.441a10.524,10.524,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,362.015,429.114Z",
    transform: "translate(-153.492 49.926)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073-2",
    "data-name": "Path 3073",
    d: "M407.483,429.114H274.721a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H412.913a10.524,10.524,0,0,1,10.513,11L418,419.066a10.523,10.523,0,0,1-10.513,10.048Z",
    transform: "translate(-31.349 49.926)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074-2",
    "data-name": "Path 3074",
    d: "M452.954,429.114H320.192a10.523,10.523,0,0,1-10.513-11l5.429-120.386a10.523,10.523,0,0,1,10.513-10.049H458.384a10.524,10.524,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,452.954,429.114Z",
    transform: "translate(90.791 49.926)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075-2",
    "data-name": "Path 3075",
    d: "M498.429,429.114H365.663a10.523,10.523,0,0,1-10.513-11l5.429-120.387a10.523,10.523,0,0,1,10.513-10.049H503.855a10.523,10.523,0,0,1,10.513,11l-5.429,120.387a10.523,10.523,0,0,1-10.51,10.049Z",
    transform: "translate(212.931 49.926)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076-2",
    "data-name": "Path 3076",
    d: "M360.366,471.436H227.6a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.524,10.524,0,0,1,233.032,330H365.8a10.523,10.523,0,0,1,10.513,11L370.88,461.387A10.523,10.523,0,0,1,360.366,471.436Z",
    transform: "translate(-157.91 163.607)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077-2",
    "data-name": "Path 3077",
    d: "M405.837,471.436H273.075a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,278.5,330H411.267a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,405.837,471.436Z",
    transform: "translate(-35.77 163.607)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078-2",
    "data-name": "Path 3078",
    d: "M451.309,471.436H318.547a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,323.975,330H456.739a10.523,10.523,0,0,1,10.513,11l-5.429,120.387A10.523,10.523,0,0,1,451.309,471.436Z",
    transform: "translate(86.373 163.607)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079-2",
    "data-name": "Path 3079",
    d: "M496.78,471.436H364.018a10.523,10.523,0,0,1-10.513-11l5.429-120.387A10.523,10.523,0,0,1,369.446,330H502.21a10.523,10.523,0,0,1,10.513,11l-5.429,120.387a10.523,10.523,0,0,1-10.514,10.049Z",
    transform: "translate(208.513 163.607)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081-2",
    "data-name": "Path 3081",
    d: "M0,74.394",
    transform: "translate(96.701 221.958)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082-2",
    "data-name": "Path 3082",
    d: "M99.518,0",
    transform: "translate(-99.518 548.711)",
    fill: "rgba(255,255,255,0)",
    stroke: "#333",
    strokeLinecap: "round",
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    transform: "translate(3751.473 4526.979) rotate(-164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M0,95.051c27.71,13.56,55.42,27.71,82.539,41.27,1.769-2.948,10.022-15.329,25.351-19.456,2.358-.59,18.866-4.127,30.657,4.716,5.306,4.127,4.126,7.075,8.254,13.56,8.843,11.791,23.583,14.149,29.478,15.329,44.217,9.433,62.493,50.7,107.889,47.754,1.769,0,33.6-2.948,39.5-19.455s-17.687-39.5-33.015-50.7C250.564,98.588,219.907,116.275,188.66,86.8c-14.15-13.56-8.255-17.1-28.889-41.269C158,43.759,126.756,6.617,102.585.721,73.106-5.764,27.71,31.968,0,95.051ZM86.076,204.709c-9.433,12.97,41.269,55.419,85.487,105.532,2.948,2.948,9.433,10.612,19.455,12.381s13.561-2.948,21.813-2.948c21.814,0,27.119,35.963,50.7,38.322,14.149,1.179,17.687-8.843,31.837-9.433,28.3-1.769,38.91,43.627,57.186,41.269,12.97-1.769,24.172-23.583,22.4-41.269-.589-6.485-2.948-10.612-24.172-37.143-30.067-36.553-34.784-40.09-39.5-42.448-17.1-9.433-21.225-2.358-40.091-13.56-19.455-11.2-21.813-21.814-33.015-21.814-15.329.59-20.634,21.224-31.836,18.866-12.381-2.358-10.023-22.993-28.889-34.784-7.074-4.716-12.38-4.127-31.836-6.485C96.688,205.889,89.613,199.4,86.076,204.709Z",
    transform: "translate(114.422 25.003)",
    fill: "#e1beab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M191.064,46.359C171.019,61.688,135.645,83.5,94.966,78.2c-27.709-3.537-1.216,76.758-80.087,0S195.192-24.979,219.954,26.9",
    transform: "translate(0 0)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M26.034,52.731A80.125,80.125,0,0,1,4.81,22.073C.683,11.461-1.086,6.155.683,2.618c6.485-9.433,43.628,8.254,91.971,27.12C187.574,66.291,202.9,58.626,224.717,83.388c25.941,28.888,11.2,46.575,32.425,96.1,10.613,24.762,51.881,106.711,136.189,126.756,54.829,12.97,128.524-1.179,165.078-50.113,35.373-47.755,26.529-116.144,21.224-159.182-5.306-41.269-17.1-70.747-11.791-73.106,6.485-2.948,30.067,32.426,44.217,67.21,12.97,33.016,37.143,90.793,11.791,151.518-22.4,53.65-70.747,77.233-84.307,84.307C463.488,364.609,389.2,336.31,374.465,331c-63.673-24.172-96.688-71.927-109.069-90.2-12.971-19.456-24.172-51.882-36.553-82.539-7.663-18.866-13.56-34.784-17.1-45.986C149.842,92.821,87.938,72.776,26.034,52.731Z",
    transform: "translate(456.864 307.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M0,18.8C5.307,36.483,16.509,62.424,40.091,80.111c24.172,18.276,40.091,12.381,96.688,30.657,22.993,7.664,52.471,17.1,84.9,37.732a294.11,294.11,0,0,1,54.239,44.807c36.553,1.179,90.793,7.664,148.57,35.374a379.377,379.377,0,0,1,58.957,35.374c.589,20.635,3.537,56.008,21.224,94.33,7.665,15.918,31.247,66.031,87.255,99.046,21.814,12.97,79,46.575,146.211,25.941,7.075-2.358,66.62-21.814,94.33-80.18,18.277-38.322,12.97-72.516,4.717-129.7-7.075-47.754-11.2-75.464-33.015-103.763C767.02,121.97,711.013,112.537,700.4,110.768c-68.979-11.791-129.7,33.016-169.794,61.314-8.255,5.9-14.74,10.612-18.865,14.149C373.784,154.985,288.3,121.969,235.236,96.618,178.049,68.909,111.428,58.886,60.726,21.154c-7.664-5.9-36.552-28.3-51.881-18.866C2.949,5.826.59,13.49,0,18.8Z",
    transform: "translate(210.521 145.475)",
    fill: "#f7c85f",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M163.516,315.417c11.791-2.948,64.262-17.1,99.046-70.158,5.9-9.433,34.784-54.829,25.351-116.144-1.769-13.56-9.433-63.673-51.291-97.278C185.331-9.431,98.665-13.559,43.836,37.144-21.015,96.69,4.926,189.84,6.1,193.967c17.1,56.6,61.314,85.486,74.874,93.74,33.015,21.224,64.852,25.941,82.539,27.709Z",
    transform: "translate(747.511 292.673)",
    fill: "#e8e1dd",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M177.4,9.886c1.77-2.358-24.17-14.149-15.327-8.254,9.433,6.485,14.739,9.433,15.328,8.254Zm-79,127.935c1.179-2.948-29.478-18.866-76.643-48.934-23.582-15.329-31.246-2.358-6.484,11.791C64.792,128.388,97.808,140.18,98.4,137.821ZM236.943,269.883c-1.178-.59-3.537,1.769-7.664,4.717a32.545,32.545,0,0,1-18.866,5.9,57.161,57.161,0,0,1-13.561-1.769,21.783,21.783,0,0,1-6.485-2.948,49.117,49.117,0,0,1-7.075-4.716c-9.433-7.075-17.1-17.687-25.94-30.068-34.2-50.7-65.441-89.614-69.57-86.666s19.457,46.575,53.651,97.278c8.843,12.97,18.866,25.351,31.246,33.605,2.948,2.358,6.485,3.537,10.023,5.306a71.235,71.235,0,0,0,10.613,2.948,50.5,50.5,0,0,0,18.865,0c11.2-2.358,19.456-8.844,22.993-14.15,2.948-5.306,2.948-9.433,1.769-9.433Z",
    transform: "translate(106.818 64.772)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M91.646,75.464C94,74.285,91.056,64.262,82.8,50.7A162.015,162.015,0,0,0,39.174,5.9,39.575,39.575,0,0,0,29.152,1.179,5.314,5.314,0,0,0,26.2.59,7.476,7.476,0,0,0,22.667,0H15.593a16.291,16.291,0,0,0-11.2,7.075,27.57,27.57,0,0,0-2.948,5.9,6.414,6.414,0,0,0-.589,2.948,25.522,25.522,0,0,1-.59,2.948A57.42,57.42,0,0,0,5.57,48.934,54.956,54.956,0,0,0,17.951,64.852c4.126,2.948,6.485,3.537,7.665,2.358,1.769-1.769-4.127-9.433-7.075-22.993a49.76,49.76,0,0,1-.589-22.993V19.456c0-.59.589-.59.589-1.179a2.165,2.165,0,0,1,1.769-.59h1.767c.59,0,.59,0,1.179.59a54.514,54.514,0,0,1,5.9,2.948A336.023,336.023,0,0,1,72.78,58.367c9.432,11.2,16.508,18.276,18.866,17.1Zm56.6,4.716c-1.179,0-2.359,2.358-2.948,7.075s.589,11.2,1.769,18.276c1.769,7.075,4.127,15.918,4.717,23.582s-1.769,17.1-6.485,21.814c-2.359,2.358-4.717,2.948-8.254,3.537a21.733,21.733,0,0,1-10.023-2.948,53.435,53.435,0,0,1-9.432-6.485c-2.948-2.358-5.9-5.306-8.844-7.664a51.483,51.483,0,0,0-15.328-10.612c-4.127-1.769-7.075-1.769-7.665-.59s.589,3.537,2.948,6.485c2.358,3.537,5.895,8.254,9.433,13.56,2.358,2.948,4.717,6.485,7.665,10.022a57.62,57.62,0,0,0,12.38,10.612c4.717,2.948,11.2,5.9,18.866,5.9a28.339,28.339,0,0,0,21.813-8.254,37.088,37.088,0,0,0,10.023-18.866,64.009,64.009,0,0,0,.589-18.277c-1.769-11.791-6.485-19.455-9.433-25.941s-5.895-11.791-7.664-15.329c-1.769-4.127-2.947-5.9-4.126-5.9Z",
    transform: "translate(250.937 226.175)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M144.48,89.821c-1.179-.59-3.538,1.769-4.127,6.485-1.179,4.717-.589,11.791,2.359,18.866,2.358,7.664,7.074,15.329,8.254,22.4.589,3.537,1.179,7.664.589,10.612-.589,3.537-1.769,4.716-3.537,5.9s-5.306,1.179-9.433.59a44.922,44.922,0,0,1-11.791-3.537c-7.074-3.537-13.56-8.254-19.456-12.381-10.612-8.843-18.277-14.739-20.045-12.381-1.769,1.769,1.179,10.023,10.613,22.4,4.717,5.9,11.2,12.97,20.634,18.276a50.852,50.852,0,0,0,16.508,6.485c5.895,1.179,13.56,1.769,21.813-1.769a19.727,19.727,0,0,0,9.433-8.843,28.884,28.884,0,0,0,4.126-11.2c1.179-7.075,0-12.97-1.769-18.866a48.279,48.279,0,0,0-7.074-13.56c-2.359-3.537-4.127-6.485-6.486-9.433-3.537-5.9-5.9-10.023-7.074-13.56s-1.769-5.9-3.537-6.485ZM.037,5.513c0,2.948,6.485,4.127,14.15,8.254a99.212,99.212,0,0,1,26.53,21.224C49.56,45.6,55.456,57.395,60.762,65.649s9.433,13.56,12.381,12.381c2.359-1.179,2.948-7.664.59-17.687A96.663,96.663,0,0,0,56.045,22.611C44.843,9.051,30.1,1.387,18.313.208,5.932-.972-.553,3.155.037,5.514Z",
    transform: "translate(328.396 249.55)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M203.031,195.757c-1.769,5.306,17.687,15.918,34.784,34.784,17.687,18.866,27.12,38.321,32.426,37.142,2.358-.59,3.537-7.075.589-16.508-2.358-9.433-8.843-22.4-18.866-33.605-10.612-11.2-22.4-18.277-31.836-21.224-9.433-3.537-15.918-2.948-17.1-.59Zm54.829-84.307c2.359-1.179-.589-13.56-12.381-30.068a124.119,124.119,0,0,0-24.761-25.351A128.622,128.622,0,0,0,181.808,35.4c-15.328-5.306-30.068-5.9-41.859-7.664-12.38-1.769-21.813-4.716-29.478-8.843C95.142,10.635,91.6-.567,89.247.022c-1.179,0-2.359,3.537-.59,9.433,1.179,5.9,5.9,14.149,14.739,20.635a55.056,55.056,0,0,0,15.328,8.844A165.81,165.81,0,0,0,137,44.829c12.97,2.948,26.53,4.716,38.911,8.843,25.94,8.254,46.575,23.583,59.546,36.553,12.969,12.381,20.045,22.4,22.4,21.224Zm-10.613,8.843c-.589,1.179.59,4.127-.589,6.485-.589,1.179-1.179,3.537-2.948,4.716-1.769,1.769-3.537,2.948-5.306,2.948-3.538,0-8.844-1.769-14.74-5.306s-12.97-8.843-20.634-13.56c-34.784-22.4-65.442-37.142-68.389-32.426s22.993,26.53,57.777,48.934c7.664,4.716,14.149,9.433,22.4,13.56a84.138,84.138,0,0,0,12.97,4.716c4.717,1.179,9.433.59,14.15-.589a19.725,19.725,0,0,0,12.381-11.2c1.769-4.127,2.358-8.843,1.179-11.791a10.161,10.161,0,0,0-4.717-5.9c-2.359-1.768-3.538-1.179-3.538-.589ZM37.365,63.695c-.59,2.358,3.537,6.485,8.843,12.381a53.076,53.076,0,0,1,12.381,26.53c1.179,10.612-1.769,21.224-5.306,28.3s-7.075,11.791-5.307,14.149c1.179,2.358,8.255,1.179,16.509-5.9a46.239,46.239,0,0,0,13.559-38.911A47.366,47.366,0,0,0,55.051,65.463C45.028,60.157,37.954,61.336,37.365,63.695Zm-13.561,0c-1.769-1.768-7.665,0-14.15,7.664A41.369,41.369,0,0,0,1.99,86.688,60.02,60.02,0,0,0,.221,107.323a62.967,62.967,0,0,0,6.485,19.455,40.6,40.6,0,0,0,11.2,12.97c7.664,5.9,14.149,6.485,15.329,4.127s-1.769-6.485-5.306-12.97a101.085,101.085,0,0,1-5.307-11.2c-1.178-4.127-2.948-9.433-3.537-14.739a61.462,61.462,0,0,1,0-14.739,66.01,66.01,0,0,1,2.359-12.381c2.358-7.075,4.126-12.381,2.358-14.15Z",
    transform: "translate(192.022 80.531)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M325.5,129.6c1.769-5.306-71.336-33.016-160.951-68.389S2.416-4.227.059.489,66.679,43.527,156.882,78.9c90.792,35.963,166.846,55.419,168.614,50.7Z",
    transform: "translate(234.043 150.222)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 108.479,
    cy: 9.433,
    rx: 108.479,
    ry: 9.433,
    transform: "translate(532.661 257.836) rotate(18.177)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M204.6,189.049c2.359-4.717-40.679-28.3-97.867-47.755S1.2,113.585.022,118.891s44.217,21.224,100.815,40.68c55.419,18.866,101.4,34.784,103.762,29.478ZM258.25,88.823C259.428,90,268.272,75.853,289.5,57.576c10.612-9.433,24.761-18.866,43.038-27.709,18.277-8.254,40.09-14.739,64.851-15.329A175.642,175.642,0,0,1,475.8,31.046a170.21,170.21,0,0,1,68.978,59.546c18.277,27.12,30.658,60.135,38.911,95.509a409.169,409.169,0,0,1,9.433,54.829c1.769,18.276,1.769,37.142-2.948,54.829-8.253,35.963-33.015,66.031-61.314,85.486-14.739,9.433-30.657,17.1-46.576,21.814a178.667,178.667,0,0,1-49.523,6.485c-32.426,0-63.673-8.254-90.2-20.045a227.545,227.545,0,0,1-67.8-45.4A223.114,223.114,0,0,1,232.9,291.043a195.416,195.416,0,0,1-19.456-47.165c-7.074-27.709-5.9-43.628-7.665-43.628-.589,0-1.178,4.127-1.769,11.791-.589,4.127,0,8.843,0,14.149,0,2.948.59,5.9.59,8.843.589,2.948.589,6.485,1.769,10.023,2.358,14.739,7.665,31.836,17.1,50.7a222.808,222.808,0,0,0,41.858,57.777,257.544,257.544,0,0,0,70.747,50.113c28.3,12.97,61.315,22.4,96.689,22.993A216.429,216.429,0,0,0,487,420.157c18.276-4.716,35.963-12.97,52.471-23.582,15.918-11.2,31.247-24.762,43.628-40.68a197.421,197.421,0,0,0,15.918-26.53c4.127-9.433,8.254-19.456,10.613-29.478,5.306-20.635,4.717-41.269,2.948-61.314a362.268,362.268,0,0,0-10.023-57.187c-8.843-36.553-21.813-71.927-42.448-101.4a180.977,180.977,0,0,0-34.784-38.322,182.874,182.874,0,0,0-41.859-25.941A180.749,180.749,0,0,0,397.976.389,169.436,169.436,0,0,0,329,19.844,181.66,181.66,0,0,0,285.37,51.68c-10.613,10.612-17.1,19.455-21.225,26.53-4.717,6.485-6.485,10.612-5.895,10.612Z",
    transform: "translate(481.107 238.167)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M273.557,128.236c.589,0,.589-5.306-1.769-14.149a154.273,154.273,0,0,0-13.561-35.374c-7.664-14.15-18.275-30.657-34.784-44.807S185.712,7.965,160.95,3.249C136.188-2.057,112.016-.289,91.382,4.428A173.918,173.918,0,0,0,38.91,25.063,161.42,161.42,0,0,0,8.843,48.645C2.358,55.13,0,59.257,0,59.846c.589.59,4.126-2.948,11.2-8.254s17.1-12.97,30.656-20.045A191.657,191.657,0,0,1,93.15,13.271c20.045-4.127,43.038-5.306,65.441-.59a137.566,137.566,0,0,1,58.956,28.3A145.735,145.735,0,0,1,252.332,82.25c8.254,13.56,12.38,25.351,15.918,33.605,3.537,7.664,4.716,12.381,5.306,12.381Z",
    transform: "translate(761.17 284.831)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M304.948,26.6c-.589,0,2.359,7.075,5.306,20.635a198.348,198.348,0,0,1,6.485,56.6c-.589,23.582-6.485,52.471-24.171,79a157.168,157.168,0,0,1-32.426,36.553,124.252,124.252,0,0,1-46.576,23.582c-17.686,4.127-35.373,3.537-51.881.59-17.1-2.948-33.6-6.485-48.344-11.791a175.027,175.027,0,0,1-69.568-45.986,182.874,182.874,0,0,1-31.836-47.165c-5.9-12.381-8.255-19.456-8.844-19.456S3.681,126.829,8.4,139.8a158.96,158.96,0,0,0,30.068,50.113A169.175,169.175,0,0,0,109.8,239.436c15.329,5.9,32.426,9.433,50.113,12.381s37.143,4.127,56.008-.589a126.1,126.1,0,0,0,50.113-25.351,174.359,174.359,0,0,0,34.194-38.911c8.255-14.149,15.329-28.889,18.277-43.038a169.277,169.277,0,0,0,4.717-40.68c-.589-24.762-5.306-44.807-10.022-57.777-3.538-12.381-7.665-18.866-8.255-18.866ZM27.855.074c-1.179-.59-4.717,2.358-10.023,8.843a97.429,97.429,0,0,0-13.559,28.3C.734,49.007-.445,60.209.145,68.463s1.769,12.97,2.948,12.97c2.948,0,3.537-19.456,10.613-41.269C20.19,18.35,30.213,1.842,27.855.074Z",
    transform: "translate(722.705 367.596)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 22.993,
    cy: 9.433,
    rx: 22.993,
    ry: 9.433,
    transform: "translate(42.376 51.947) rotate(35.095)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 30.068,
    cy: 9.433,
    rx: 30.068,
    ry: 9.433,
    transform: "translate(69.845 15.109) rotate(37.426)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_218",
    "data-name": "Ellipse 218",
    transform: "matrix(0.454, -0.891, 0.891, 0.454, 850.602, 510.993)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.705,
    cy: 7.19,
    rx: 75.705,
    ry: 7.19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.705,
    cy: 7.19,
    rx: 77.705,
    ry: 9.19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    transform: "translate(952.568 491.96) rotate(-149)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.706,
    cy: 7.193,
    rx: 75.706,
    ry: 7.193,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.706,
    cy: 7.193,
    rx: 77.706,
    ry: 9.193,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoHistory);
export default __webpack_public_path__ + "static/media/NoHistory.b7c4165b3aca12906594dd1b0b297812.svg";
export { ForwardRef as ReactComponent };